import { COMMON } from '../../util/localizations'

const LOCALIZATIONS = {
    en: {
        mobile: `${ COMMON.appName } must be accessed through MetaMask's browser to enable full functionality on mobile devices. MetaMask is available for download on {0}`,
        appStore: 'the iOS App Store',
        googlePlay: 'Google Play',
        safari: 'MetaMask does not support a plugin for Safari. As a result, you will not be able to reach any NFT related content.'
    }
}

export default LOCALIZATIONS;